import { render, staticRenderFns } from "./UpdateUserInfoModal.vue?vue&type=template&id=79370717&"
import script from "./UpdateUserInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79370717')) {
      api.createRecord('79370717', component.options)
    } else {
      api.reload('79370717', component.options)
    }
    module.hot.accept("./UpdateUserInfoModal.vue?vue&type=template&id=79370717&", function () {
      api.rerender('79370717', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/UpdateUserInfoModal.vue"
export default component.exports